import React from 'react';
import { Instagram, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-warmwhite py-14 border-t border-brand-sand/50" data-id="element-14">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-15">
        <p className="font-serif text-2xl text-brand-ink mb-2" data-id="element-16">Helen Gerberg</p>
        <p className="font-serif text-lg italic text-brand-eucalyptus mb-8" data-id="element-17">
          Devela tu verdadero ser.
        </p>

        <div className="flex items-center justify-center gap-6 mb-8" data-id="element-18">
          <a href="https://www.instagram.com/helengerberg/" target="_blank" rel="noopener noreferrer" aria-label="Instagram de Helen Gerberg" className="text-brand-ink/70 hover:text-brand-eucalyptus transition-colors" data-id="element-19">
            <Instagram className="w-5 h-5" strokeWidth={1.5} data-id="element-20" />
          </a>
          <a href="mailto:hola@helengerberg.com" aria-label="Contacto por correo" className="text-brand-ink/70 hover:text-brand-eucalyptus transition-colors" data-id="element-21">
            <Mail className="w-5 h-5" strokeWidth={1.5} data-id="element-22" />
          </a>
        </div>

        <div className="flex items-center justify-center gap-5 mb-6 text-xs font-sans text-brand-ink/60" data-id="element-23">
          <a href="#" className="hover:text-brand-eucalyptus transition-colors" data-id="element-24">
            Privacidad
          </a>
          <span className="text-brand-ink/30" data-id="element-25">·</span>
          <a href="#" className="hover:text-brand-eucalyptus transition-colors" data-id="element-26">
            Términos
          </a>
        </div>

        <p className="font-sans text-xs text-brand-ink/50" data-id="element-27">
          © 2026 Helen Gerberg. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}